import {PortfolioAccountContextProvider} from '#/components/portfolio/context/portfolio-account-context';
import {PortfolioAssetsContextProvider} from '#/components/portfolio/context/portfolio-assets-context';
import {PortfolioInfo} from '#/components/portfolio/portfolio-info';
import {PortfolioTabs} from '#/components/portfolio/portfolio-tabs';
import {FunctionComponent} from 'react';
import {Hex} from 'viem';

export const Portfolio: FunctionComponent<{account: Hex; isCurrentUser: boolean}> = ({account, isCurrentUser}) => {
  return (
    <PortfolioAccountContextProvider account={account} isCurrentUser={isCurrentUser}>
      <PortfolioAssetsContextProvider>
        <div className='w-full h-full @container/portfolio px-5 pt-0 sm:px-10 max-w-screen-2xl mx-auto'>
          <div
            className={
              'w-full h-full flex flex-col @4xl/portfolio:flex-row gap-x-5 overflow-y-scroll @4xl/portfolio:overflow-y-hidden'
            }
          >
            <div
              className={
                'w-full @4xl/portfolio:w-[400px] @4xl/portfolio:h-full @container/portfolio-info @4xl/portfolio:overflow-y-scroll relative'
              }
            >
              <PortfolioInfo />
            </div>
            <div className={'h-full @4xl/portfolio:grow overflow-visible @4xl/portfolio:overflow-y-scroll relative'}>
              <PortfolioTabs />
            </div>
          </div>
        </div>
      </PortfolioAssetsContextProvider>
    </PortfolioAccountContextProvider>
  );
};
